import type { SVGProps } from 'react';
const SvgLocalFlorist = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#local_florist_svg__a)">
      <path
        fill="currentColor"
        d="M12 22a9 9 0 0 0 9-9 9 9 0 0 0-9 9ZM5.6 10.25a2.5 2.5 0 0 0 3.92 2.06l-.02.19a2.5 2.5 0 0 0 5 0l-.02-.19c.4.28.89.44 1.42.44a2.5 2.5 0 0 0 2.5-2.5c0-1-.59-1.85-1.43-2.25.84-.4 1.43-1.25 1.43-2.25a2.5 2.5 0 0 0-3.92-2.06l.02-.19a2.5 2.5 0 0 0-5 0l.02.19c-.4-.28-.89-.44-1.42-.44a2.5 2.5 0 0 0-2.5 2.5c0 1 .59 1.85 1.43 2.25-.84.4-1.43 1.25-1.43 2.25ZM12 5.5a2.5 2.5 0 0 1 0 5 2.5 2.5 0 0 1 0-5ZM3 13a9 9 0 0 0 9 9 9 9 0 0 0-9-9Z"
      />
    </g>
    <defs>
      <clipPath id="local_florist_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLocalFlorist;
